import React from 'react';
import { motion } from 'framer-motion';
import { useContacts } from '../contexts/ContactContext';
import { useCampaigns } from '../contexts/CampaignContext';
import StatsCard from '../components/Dashboard/StatsCard';
import RecentActivity from '../components/Dashboard/RecentActivity';
import QuickActions from '../components/Dashboard/QuickActions';
import CampaignOverview from '../components/Dashboard/CampaignOverview';
import SafeIcon from '../common/SafeIcon';
import { FiMail, FiPhone, FiTrendingUp, FiUsers } from 'react-icons/fi';


const Dashboard = () => {
  const { getContactStats } = useContacts();
  const { getCampaignStats } = useCampaigns();
  
  const contactStats = getContactStats();
  const campaignStats = getCampaignStats();

  const stats = [
    {
      title: 'Total Contacts',
      value: contactStats.total,
      change: `+${contactStats.recent} this month`,
      icon: FiUsers,
      color: 'blue'
    },
    {
      title: 'Active Campaigns',
      value: campaignStats.active,
      change: `${campaignStats.total} total campaigns`,
      icon: FiMail,
      color: 'green'
    },
    {
      title: 'Emails Sent',
      value: campaignStats.sent,
      change: `${campaignStats.delivered} delivered`,
      icon: FiTrendingUp,
      color: 'purple'
    },
    {
      title: 'AI Calls Made',
      value: '24',
      change: '+12% this week',
      icon: FiPhone,
      color: 'orange'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Welcome Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white"
      >
        <h1 className="text-2xl font-bold mb-2">Welcome to Prosper CRM</h1>
        <p className="text-blue-100">
          Manage your customer relationships with AI-powered calling and email automation
        </p>
      </motion.div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <StatsCard {...stat} />
          </motion.div>
        ))}
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Quick Actions */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
        >
          <QuickActions />
        </motion.div>

        {/* Campaign Overview */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="lg:col-span-2"
        >
          <CampaignOverview />
        </motion.div>
      </div>

      {/* Recent Activity */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        <RecentActivity />
      </motion.div>
    </div>
  );
};

export default Dashboard;